import { RichUtils, Modifier, EditorState } from 'draft-js';
import { noop } from 'lodash-es';

import S from './styles';

const insertPageBreak = (editorState) => {
  const content = editorState.getCurrentContent();
  const selection = editorState.getSelection();

  const newContent = Modifier.splitBlock(content, selection);
  let newState = EditorState.push(editorState, newContent, 'split-block');

  newState = RichUtils.toggleBlockType(newState, 'page-break');

  const afterBreakContent = Modifier.splitBlock(
    newState.getCurrentContent(),
    newState.getSelection(),
  );
  newState = EditorState.push(newState, afterBreakContent, 'split-block');

  // The new block inherits page-break type from the split, reset it to unstyled
  const resetContent = Modifier.setBlockType(
    newState.getCurrentContent(),
    newState.getSelection(),
    'unstyled',
  );
  newState = EditorState.push(newState, resetContent, 'change-block-type');

  return newState;
};

const PageBreak = ({ editor, onChange = noop }) => {
  const handleClick = (e) => {
    e.preventDefault();
    const newState = insertPageBreak(editor);
    onChange(newState);
  };

  return (
    <span className="normal" onClick={handleClick} title="Page Break">
      <S.PageBreakIcon />
    </span>
  );
};

export default PageBreak;
